<template>
  <div :style="{height:formDivHeight+'px',overflow: 'auto'}">
    <el-form :model="roleForm" :inline="true" :rules="formRules" label-position="right" ref="roleFormEl" label-width="100px" class="demo-ruleForm">
      <el-form-item label="角色名称" prop="roleName">
        <el-input ref="roleNameEl" v-model="roleForm.roleName" style="width: 100%" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item label="备注信息" prop="roleRemark">
        <el-input v-model="roleForm.roleRemark" style="width: 100%" placeholder="输入备注信息"></el-input>
      </el-form-item>
    </el-form>
    <el-table ref="pmdTable" background="true" :height="tableHeight" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)" :data="pmdTableData" row-key="id"
              :tree-props="{children: 'children'}" default-expand-all border style="width: 100%;">
      <el-table-column type="index" label="序号" fixed="left" width="50" />
      <el-table-column prop="permissionname" label="菜单名称" width="260" />
      <el-table-column prop="id" label="选择" width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked" @change="checked=>permissChange(checked,scope.row)" :key="scope.row.id"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="method" label="方法">
        <template slot-scope="scope">
          <el-checkbox :label="item.methodPid" :key="item.methodPid" v-model="item.checked" @change="checked=>methodChange(checked,scope.row)" v-for="item in scope.row.method">
            {{item.methodName}}
          </el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center">
      <el-button type="primary" style="width: 100px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
      <el-button type="danger" style="width: 100px" @click="closeWindow()">关闭</el-button>
    </div>
  </div>
</template>
<script>
import { appjs } from "@/utiljs/apputil";
export default {
  props: {
    closeWindow: {
      type: Function
    },
    rolePerData: {
      type: Object
    }
  },
  data () {
    return {
      formDivHeight: (document.documentElement.clientHeight - 100),
      tableHeight: (document.documentElement.clientHeight - 205) + 'px',
      saveButValue: '保 存',
      loading: true,
      saveButState: false,
      pmdTableData: [],
      rolePermissionIds: [],
      permissionMethodIds: [],
      parentselcount: 0,
      methodobj: {},
      roleForm: {
        rolePid: '',
        roleName: '',
        roleRemark: '',
        permissionIds: '',
        methodJson: ''
      },
      formRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.loadPmdTableData();
  },
  methods: {
    resertForm (rolePerData) {
      this.saveButValue = '更 新';
      this.saveButState = false;
      this.formDivHeight = (document.documentElement.clientHeight - 100);
      this.methodobj = {};
      this.roleForm.roleName = rolePerData.roleName;
      this.roleForm.roleRemark = rolePerData.roleRemark;
      this.roleForm.rolePid = rolePerData.rolePid;
      this.rolePermissionIds = [];
      this.permissionMethodIds = [];
      if (rolePerData.permissionIds != null) {
        this.rolePermissionIds = rolePerData.permissionIds.split(",");
      }
      if (rolePerData.permissionMethodIds != null) {
        this.permissionMethodIds = rolePerData.permissionMethodIds.split(",");
      }
      this.setRoleSelectedPermission(this.pmdTableData);
    },
    setRoleSelectedPermission (arr) {
      arr.forEach((item) => {
        item.checked = false;
        this.rolePermissionIds.forEach((id) => {
          if (id == item.id) {
            item.checked = true;
          }
        })
        if (item.method) {
          item.method.forEach((obj) => {
            obj.checked = false;
            this.permissionMethodIds.forEach((mid) => {
              if (mid == obj.methodPid) {
                obj.checked = true;
              }
            })
          });
        }
        if (item.children && item.children.length > 0) {
          this.setRoleSelectedPermission(item.children);
        }
      })
    },
    getOhterParentSelect (arr, perentPid) {
      arr.forEach((item) => {
        if (item.id == perentPid) {
          //找到上级
          if (item.children && item.children.length > 0) {
            item.children.forEach((obj) => {
              if (obj.checked) {
                this.parentselcount++;
              }
            });
          }
          this.getOhterParentSelect(this.pmdTableData, item.parentpermissionpid);
        }
        if (item.children && item.children.length > 0) {
          this.getOhterParentSelect(item.children, perentPid);
        }
      })
    },
    changeParentSelected (arr, perentPid, checked) {
      arr.forEach((item) => {
        if (item.id == perentPid) {
          item.checked = checked;
          this.changeParentSelected(this.pmdTableData, item.parentpermissionpid, checked);
        }
        if (item.children && item.children.length > 0) {
          this.changeParentSelected(item.children, perentPid, checked);
        }
      })
    },
    selectedChildren (arr, checked) {
      arr.forEach((item) => {
        item.checked = checked;
        if (item.method) {
          item.method.forEach((mth) => {
            mth.checked = checked;
          })
        }
        if (item.children && item.children.length > 0) {
          this.selectedChildren(item.children, checked);
        }
      })
    },
    onlyParent (arr, perentPid) {
      arr.forEach((item) => {
        if (item.id == perentPid) {
          let flag = true;
          item.children.forEach((obj) => {
            if (obj.checked) {
              flag = false;
            }
          });
          if (flag) {
            item.checked = false;
          }
        }
        if (item.children && item.children.length > 0) {
          this.onlyParent(item.children, perentPid);
        }
      });
    },
    permissChange (checked, obj) {
      if (obj.method) {
        obj.method.forEach((item) => {
          item.checked = checked;
        })
      } else {
        this.selectedChildren(obj.children, checked)
      }
      this.parentselcount = 0;
      this.getOhterParentSelect(this.pmdTableData, obj.parentpermissionpid);
      if (this.parentselcount > 0 && !checked) {
        this.onlyParent(this.pmdTableData, obj.parentpermissionpid);
        return;
      }
      this.changeParentSelected(this.pmdTableData, obj.parentpermissionpid, checked);
    },
    methodChange (checked, obj) {
      if (checked) {//选择，把父项勾起
        obj.checked = checked;
      } else {
        //判断是否全不选
        let flag = true;
        obj.method.forEach((obj) => {
          if (obj.checked) {
            flag = false;
          }
        });
        if (flag) {
          obj.checked = false;
        }
      }
      this.parentselcount = 0;
      //找上级，查找上级是否还有其他勾选项
      this.getOhterParentSelect(this.pmdTableData, obj.parentpermissionpid);
      if (this.parentselcount > 0 && !checked) {
        this.onlyParent(this.pmdTableData, obj.parentpermissionpid);
        return;
      }
      this.changeParentSelected(this.pmdTableData, obj.parentpermissionpid, checked);
    },
    loadPmdTableData () {
      this.loading = true;
      let _self = this;
      let params = this.searchForm;
      appjs.httpRequest('permission/queryPermsssionAndMethod', params).then(
        (data) => {
          _self.loading = false;
          if (data.retCode && data.retCode != "ok") {
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.pmdTableData = data;
            _self.resertForm(_self.rolePerData);
          }
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          _self.loading = false;
        }
      );
    },
    getSelectedPermission (arr) {
      arr.forEach((item) => {
        if (item.checked && item.permissionurl) {
          this.roleForm.permissionIds += item.id + ",";
          let methodids = "";
          if (item.method) {
            item.method.forEach((obj) => {
              if (obj.checked) {
                methodids += obj.methodPid + ",";
              }
            });
          }
          this.methodobj["method" + item.id] = methodids;
        }
        if (item.children && item.children.length > 0) {
          this.getSelectedPermission(item.children);
        }
      })
    },
    submitForm () {
      this.roleForm.permissionIds = "";
      this.getSelectedPermission(this.pmdTableData);
      this.roleForm.methodJson = JSON.stringify(this.methodobj);
      this.$refs.roleFormEl.validate((valid) => {
        if (valid) {
          if (this.roleForm.permissionIds == "") {
            appjs.showWarningMsg("请选择权限信息")
            return;
          }
          let params = this.roleForm;
          this.saveButValue = '更新中....'
          this.saveButState = true;
          let _self = this;
          appjs.httpRequest('role/updateRole', params, 'post').then((data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.showErrorMsg(data.retMsg);
              _self.saveButValue = '更新';
              _self.saveButState = false;
            } else {
              _self.saveButValue = '更新成功';
              _self.closeWindow(data.retMsg);
            }
          }).catch((error) => {
            _self.saveButState = false;
            _self.loginText = '更新';
            appjs.showErrorMsg("异常：" + error)
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>
